import clsx from "clsx";
import { toShortDateString } from "../../../../helpers/FormatDate";
import { NotificationType } from "../../enums/NotificationType";
import { NotificationIcon } from "../atoms/NotificationIcon";
import { useHistory } from "react-router-dom";

type Props = {
    type: NotificationType;
    title: string;
    message: string;
    createdAt: string;
    isRead: boolean;
    pageLink: string | null;
}

export const NotificationsItem = ({ type, title, message, isRead, createdAt, pageLink }: Props) => {
    const history = useHistory();
    const _handleClick = () => {
        if(!pageLink)
            return;
        history.push(pageLink);
    }
    return (
        <div className={clsx('notification-item', { 'unread': !isRead }, { 'cursor-pointer': pageLink })} onClick={_handleClick}>
            <div className="notification-head">
                <span className="icon">
                    <NotificationIcon type={type} />
                </span>
                <span>
                    {  toShortDateString(createdAt)  }
                </span>
            </div>
            <span className="title"> {title} </span>
            <span> {message} </span>
            { !!pageLink && <span className="text-muted mt-1">click to view</span>}
        </div>
    )
}